import React from 'react';
import './notification.css';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Notification = props => {
    const { amountOfNotifications, size } = props;

    const notificationClasses = classNames({
        notification: true,
        'notification--large': size === 'large',
    });

    return <div className={notificationClasses}>{amountOfNotifications}</div>;
};

Notification.defaultProps = {
    size: 'medium',
};

Notification.propTypes = {
    amountOfNotifications: PropTypes.number,
    size: PropTypes.oneOf(['medium', 'large']),
};

export { Notification };
